import React from 'react';
import _ from 'lodash';

import component, {classnames} from './component';

export const Table = component('Table', {

  propTypes: {
    size: React.PropTypes.oneOf(['normal', 'compact'])
  },

  getDefaultProps() {
    return {
      size: 'normal',
      zeroMargin: false
    }
  },

  render() {
    let content = <table className={classnames('Table', 'Table--' + this.props.size, this.props.className)}>
      <tbody>
        {this.props.children}
      </tbody>
    </table>;
    if(!this.props.zeroMargin){
      content = <div style={{marginLeft: -32, marginRight: -32}}>
        {content}
      </div>;
    }
    return content;
  }

});

export const Tr = component('Tr', ({className, children}) =>
  <tr className={classnames('Table-Tr', className)}>
    {children}
  </tr>
);

const thTdProps = {
  align: React.PropTypes.oneOf(['left', 'right']),
  width: React.PropTypes.string
};

const thTdDefaultProps = {
  align: 'left'
};

export const Th = component('Th', {

  propTypes: thTdProps,

  getDefaultProps() {
    return thTdDefaultProps;
  },

  render() {
    const st = this.props.align === 'left' ? null : {textAlign: this.props.align};
    return (
        <th width={this.props.width} className={classnames('Table-Th', this.props.className)}
            style={st}>
          {this.props.children}
        </th>
    );
  }

});

export const Td = component('Td', {

  propTypes: thTdProps,

  getDefaultProps() {
    return thTdDefaultProps
  },

  render() {
    const st = this.props.align === 'left' ? null : {textAlign: this.props.align};
    return (
        <td width={this.props.width} className={classnames('Table-Td', this.props.className)}
            style={st}>
          {this.props.children}
        </td>
    );
  }

});



// WEBPACK FOOTER //
// ./src/components/Table.js